import { useEffect } from 'react'
import { Toaster as Sonner, toast as showSonner } from 'sonner'
import { Toast } from './toast.server'
import { v4 as uuid } from 'uuid'

export function Toaster({ toast }: { toast?: Toast | null }) {
  return (
    <>
      <Sonner closeButton position="bottom-right" />
      {toast ? <ShowToast toast={toast} /> : null}
    </>
  )
}

function ShowToast({ toast }: { toast: Toast }) {
  const { id, type, title, description } = toast
  useEffect(() => {
    setTimeout(() => {
      showToast({ id, description, title, type })
    }, 0)
  }, [description, id, title, type])
  return null
}

export function showToast(toast: Omit<Toast, 'id'> & { id?: string }) {
  showSonner[toast.type](toast.title, { id: toast.id ?? uuid(), description: toast.description })
}

export function showErrorToast(toast: Omit<Toast, 'type' | 'id'> & { id?: string }) {
  showToast({ ...toast, type: 'error' })
}

export function showWarningToast(toast: Omit<Toast, 'type' | 'id'> & { id?: string }) {
  showToast({ ...toast, type: 'warning' })
}
